// docs/149 — a clothing piece's dye in words. A piece is dyed only where the body wears it (docs/129 §8, the
// pieces `ITEM_DYES` lists); a weapon, a ring or anything in the pack keeps its colour and says nothing. Pure;
// covered by dyes.test.ts.
import { DYES, ITEM_DYES } from '../../game/itemDyes.gen';

/** Whether a piece takes a dye on the body at all (docs/142 DY7). */
export const dyeable = (def: number): boolean => ITEM_DYES[def] !== undefined;

/** "Dyed plum color", or nothing when the piece is undyed (dye 0) or cannot take a dye. */
export function dyedLine(def: number, dye: number): string | undefined {
  const name = DYES.find((d) => d.id === dye)?.name;
  return name && dyeable(def) ? `Dyed ${name.toLowerCase()} color` : undefined;
}
